import { useEffect, useState } from "react";

const useCheckMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  const handleCheckMobile = () => {
    const { userAgent, maxTouchPoints } = window.navigator;
    const mac = /Macintosh/i.test(userAgent) && maxTouchPoints > 0;
    const mobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|mobi/i.test(
        userAgent
      );
    setIsMobile(mac || mobile);
  };

  useEffect(() => {
    handleCheckMobile();
  }, []);

  return isMobile;
};

export default useCheckMobile;
